import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from '../types';

const largeIcon = (
  <path d="M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4ZM17 14H7C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12H17C17.55 12 18 12.45 18 13C18 13.55 17.55 14 17 14ZM17 11H7C6.45 11 6 10.55 6 10C6 9.45 6.45 9 7 9H17C17.55 9 18 9.45 18 10C18 10.55 17.55 11 17 11ZM17 8H7C6.45 8 6 7.55 6 7C6 6.45 6.45 6 7 6H17C17.55 6 18 6.45 18 7C18 7.55 17.55 8 17 8Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.565 2C2.70067 2 2 2.70067 2 3.565V9.435C2 10.2993 2.70067 11 3.565 11H10.0858C10.2012 11 10.3119 11.0458 10.3934 11.1274L12.6941 13.5582C13.176 14.0401 14 13.6988 14 13.0172V3.565C14 2.70067 13.2993 2 12.435 2H3.565ZM4.93506 5.50006C4.93506 5.18802 5.18802 4.93506 5.50006 4.93506H10.5001C10.8121 4.93506 11.0651 5.18802 11.0651 5.50006C11.0651 5.8121 10.8121 6.06506 10.5001 6.06506H5.50006C5.18802 6.06506 4.93506 5.8121 4.93506 5.50006ZM5.50006 6.93506C5.18802 6.93506 4.93506 7.18802 4.93506 7.50006C4.93506 7.8121 5.18802 8.06506 5.50006 8.06506H10.5001C10.8121 8.06506 11.0651 7.8121 11.0651 7.50006C11.0651 7.18802 10.8121 6.93506 10.5001 6.93506H5.50006Z"
  />
);

export const CommentIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Comment" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
